<cb-dialog>
    <form class="flex-col flex" #specTemplateForm="ngForm">
        @if (data.baseTemplateName) {
            <cb-input
                label="Base Template"
                [readonly]="true"
                [ngModel]="data.baseTemplateName"
                [ngModelOptions]="{ standalone: true }"
            ></cb-input>
        }
        <cb-input
            label="Name"
            name="name"
            [required]="true"
            [(ngModel)]="mappedItem.name"
        ></cb-input>
        <mat-radio-group
            class="cb-margin-top-2x flex-col flex"
            [(ngModel)]="templateType"
            (ngModelChange)="onTemplateTypeChange($event)"
            [ngModelOptions]="{ standalone: true }"
        >
            <mat-radio-button class="mat-accent" [value]="0">Nationwide Template </mat-radio-button>
            <mat-radio-button class="cb-margin-top business-enitities-radio" [value]="1">
                Regional Template
                <div class="flex-col flex">
                    @for (item of businessEnitities; track item) {
                        <cb-checkbox
                            [label]="item.name"
                            [name]="'region' + item.id"
                            [disabled]="templateType !== 1"
                            [ngModel]="isRegionChecked(item.id)"
                            (ngModelChange)="templateType = 1; onRegionChanged(item.id, $event)"
                        ></cb-checkbox>
                    }
                </div>
            </mat-radio-button>
            <mat-radio-button class="cb-margin-top projects-radio" [value]="2">
                <div class="flex-row flex center-center layoutGap-16">
                    <span> Project Template</span>
                    <cb-select
                        label="Project"
                        name="project"
                        [required]="true"
                        [options]="projects"
                        [disabled]="templateType !== 2"
                        [(ngModel)]="mappedItem.projectId"
                        (ngModelChange)="templateType = 2"
                    ></cb-select>
                </div>
            </mat-radio-button>
        </mat-radio-group>
        <div class="flex-row flex">
            <cb-select
                label="Tier"
                [required]="true"
                name="tierRange"
                [options]="tierRanges"
                [disabled]="isProject"
                [(ngModel)]="mappedItem.tierRange"
            ></cb-select>
        </div>
        <cb-checkbox
            label="Active"
            name="isActive"
            class="cb-margin-top-2x"
            [(ngModel)]="mappedItem.isActive"
        ></cb-checkbox>
    </form>
    <div actions>
        <span class="flex"></span>
        <button
            mat-raised-button
            class="save-button"
            color="primary"
            (click)="onSaveClicked()"
            [disabled]="!specTemplateForm.dirty || !specTemplateForm.valid"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
